module.exports = __webpack_public_path__ + "static/media/University01.3de07e75.png";